import CacheableDataObject from './CacheableDataObject';

/**
 * A meal's slot on the calendar. The database stores these ids in `meals.type`, an INT column
 * that php-activerecord casts on the way in, so an untyped meal arrives as 0 whether it was sent
 * as null, '' or the text "None". OTHER is that 0 given a name: the calendar files those meals
 * in an "Other" row under the four slots.
 */
export default class MealType extends CacheableDataObject {
	static types = {
		OTHER: 0,
		BREAKFAST: 1,
		LUNCH: 2,
		DINNER: 3,
		SNACK: 4,
	};

	static exists(id) {
		return MealType.hasCached(id);
	}

	/**
	 * Any value a type can arrive as, from the API or from a <select>, as one of the integer ids.
	 * Anything that is not one of the four slots is OTHER.
	 */
	static normalize(value) {
		const id = typeof value === 'number' ? value : Number.parseInt(value, 10);
		if(Number.isInteger(id) && id >= MealType.types.BREAKFAST && id <= MealType.types.SNACK) {
			return id;
		}
		return MealType.types.OTHER;
	}

	/** The four labelled slots a calendar day shows, in the order it shows them. */
	static slots() {
		return [
			MealType.retrieve({ id: MealType.types.BREAKFAST, name: 'Breakfast', shortName: 'Bfast', key: 'breakfast' }),
			MealType.retrieve({ id: MealType.types.LUNCH, name: 'Lunch', shortName: 'Lunch', key: 'lunch' }),
			MealType.retrieve({ id: MealType.types.DINNER, name: 'Dinner', shortName: 'Dinner', key: 'dinner' }),
			MealType.retrieve({ id: MealType.types.SNACK, name: 'Snack', shortName: 'Snack', key: 'snack' }),
		];
	}

	/** The row for untyped meals, which sits under the four slots. */
	static other() {
		return MealType.retrieve({ id: MealType.types.OTHER, name: 'Other', shortName: 'Other', key: 'other' });
	}

	/** Every type, None first, for the day view's <select>. */
	static all() {
		return [
			MealType.retrieve({ id: MealType.types.OTHER, name: 'None' }),
			...MealType.slots(),
		];
	}
}
